/**
 * Auth Debug Utility
 * Helps with debugging authentication issues
 */

export const clearAllAuthData = () => {
  try {
    // Clear localStorage
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.includes('supabase')) {
        keysToRemove.push(key);
      }
    }
    
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
      console.log(`Removed localStorage key: ${key}`);
    });
    
    // Clear sessionStorage
    sessionStorage.clear();
    console.log('Cleared sessionStorage');
    
    // Clear specific auth-related items
    localStorage.removeItem('supabase.auth.token');
    localStorage.removeItem('sb-aiskcpmikgoprxdbqbhc-auth-token');
    
    console.log('All auth data cleared');
  } catch (error) {
    console.error('Error clearing auth data:', error);
  }
};

export const logAuthState = () => {
  console.log('=== Auth Debug Info ===');
  console.log('localStorage keys:', Object.keys(localStorage));
  console.log('sessionStorage keys:', Object.keys(sessionStorage));
  
  // Check for Supabase keys
  const supabaseKeys = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.includes('supabase')) {
      supabaseKeys.push(key);
    }
  }
  
  console.log('Supabase keys:', supabaseKeys);
  
  // Check specific auth token
  const authToken = localStorage.getItem('sb-aiskcpmikgoprxdbqbhc-auth-token');
  console.log('Auth token present:', !!authToken);
  
  if (authToken) {
    try {
      const parsed = JSON.parse(authToken);
      console.log('Auth token expires at:', new Date(parsed.expires_at * 1000));
      console.log('Auth token user:', parsed.user?.email);
    } catch (e) {
      console.log('Could not parse auth token');
    }
  }
  
  console.log('=== End Auth Debug Info ===');
};

// Add to window for easy access in dev tools
if (typeof window !== 'undefined') {
  window.clearAllAuthData = clearAllAuthData;
  window.logAuthState = logAuthState;
}
